var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBrushIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "15px",
    viewBox: "0 0 18 15",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M5.9175,8.56397237 L5.979,8.56609211 C7.898,8.64146053 8.884,10.7065553 8.084,12.2450132 C7.356,13.6468658 5.575,14.1753868 4.064,14.1753868 C4.015,14.1753868 3.967,14.1753868 3.919,14.1735026 C2.584,14.1442974 0.548,13.5846868 4.17443857e-13,12.2205184 C0.941,11.9718026 1.889,11.60815 2.505,10.8638868 C2.997,10.2703605 3.264,9.61842368 3.934,9.16527105 C4.489,8.78842895 5.169,8.56326579 5.856,8.56326579 C5.897,8.56326579 5.938,8.56420789 5.979,8.56609211 Z M15.8917,1.43884904e-13 C16.2757,0.00376842105 16.6367,0.146968421 16.9077,0.402278947 C17.1827,0.6623 17.3347,1.00805263 17.3347,1.37453158 C17.3347,1.72970526 17.1907,2.06697895 16.9297,2.32417368 L16.9297,2.32417368 L9.1877,9.9524 C9.0997,9.69708947 8.9817,9.44837368 8.8337,9.21378947 C8.3477,8.44408947 7.6037,7.91745263 6.7337,7.70830526 L6.7337,7.70830526 L14.8677,0.380610526 C15.1407,0.134721053 15.4987,1.43884904e-13 15.8757,1.43884904e-13 L15.8757,1.43884904e-13 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Wireframes",
    stroke: "none",
    strokeWidth: 1,
    fill: "",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "4-V.4",
    transform: "translate(-17.000000, -641.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Left-panel/Asset/Comments/Modal+Tools",
    transform: "translate(0.000000, 589.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(16.000000, 50.873684)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons/brush",
    transform: "translate(0.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "UI/Colors/Grey-icons",
    transform: "translate(1.000000, 1.884211)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "var(--color, #020303)",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask-2)",
    fill: "var(--color, #586A81)",
    id: "Rectangle-8"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1.000000, -1.884211)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 20,
    height: 18.8421053
  })))))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrushIcon);
export default __webpack_public_path__ + "static/media/brush-icon.be77d7e5225a185a6deede3a15cd5ec3.svg";
export { ForwardRef as ReactComponent };